import React from "react";
import PropTypes from "prop-types";
import {Redirect, Route} from "react-router-dom";


import Layout from "../../components/Layout";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {clearUser} from "../../redux/actions/userActions";
import {clearPanel} from "../../redux/actions/panelActions";

const PanelRoute = ({
                      component: Component,
                      LayoutProps,
                      scrollTop = true,
                      ...props
                    }) => {
  scrollTop && window.scrollTo(0, 0);
  const dateTime = (new Date()).getTime();
  if (!props.email || props.email.length === 0 || !props.expireSession || props.expireSession < dateTime) {
    const clearUser = props.clearUser;
    const clearPanel = props.clearPanel;
    clearUser();
    clearPanel();
    return <Redirect
      to={{
        pathname: "/login"
      }}
    />
  }
  return <Route {...props}>
    <Layout {...LayoutProps}>
      <Component {...props} />
    </Layout>
  </Route>
};

PanelRoute.propTypes = {
  path: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
  exact: PropTypes.bool,
  email: PropTypes.string.isRequired,
  expireSession: PropTypes.number,
  LayoutProps: PropTypes.object,
  scrollTop: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    email: state.user.email,
    expireSession: state.user.expireSession
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      clearUser: clearUser,
      clearPanel: clearPanel
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PanelRoute);